import React from "react";

export default function Legend({ pxWidth, pxHeight, data, colors, opacity }) {
    return (
        <>
            {data.map((value, index) => (
                <g key={index}>
                    <rect
                        x={pxWidth * 0.6}
                        y={pxHeight * 0.06 + pxHeight * 0.165 * index}
                        height={pxHeight * 0.06}
                        width={pxHeight * 0.06}
                        fill={colors[index]}
                        opacity={opacity}
                    />
                    <foreignObject
                        x={pxWidth * 0.65}
                        y={pxHeight * 0.055 + pxHeight * 0.165 * index}
                        width={pxWidth * 0.35}
                        height={pxHeight * 0.15}
                    >
                        <div
                            xmlns="http://www.w3.org/1999/xhtml"
                            style={{
                                fontSize: `${pxHeight * 0.06}px`,
                                lineHeight: `${pxHeight * 0.06}px`,
                                whiteSpace: "normal",
                                textAlign: "left",
                            }}
                        >
                            - {value.label}
                        </div>
                    </foreignObject>
                </g>
            ))}
        </>
    );
}
